// extracted by mini-css-extract-plugin
module.exports = {"halfScreen":"modelLoader_halfScreen__1AOR0"};